/* tslint:disable */
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { IAssignmentGradeProps } from '../../../../models/components/assignment-grade-modal';
import { ITranslationModalProps } from '../../../../models/components/translation';

const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;

class TranslationModal extends React.Component<ITranslationModalProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {};
    }

    render() {
        return (
            <>
                <div className="info-box mt-2">
                    <p><span>{this?.props?.selectedItem?.globalizationKey} </span> {T.t('r_changing_localization_key')}</p>
                </div>
                <div className="form-input form-group note-pad mb-0">
                    <input
                        id="bulkGradeInput"
                        defaultValue={this?.props?.selectedItem?.globalizationValue}
                        onChange={(e: any) => { this.props.onChangeText(e.target.value) }} type="text" placeholder={T.t('r_create_new_text')}
                    />
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: IAppState, ownProps: ITranslationModalProps): ITranslationModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: ITranslationModalProps = Object.assign({}, ownProps, {

    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CTranslationModal = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(TranslationModal);

export default CTranslationModal;
